import { Box, Container, Typography, Button } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import { motion } from "framer-motion";
import ctaBg from "../../assets/agent-bg.jpg";

export default function FinalCTA() {
  return (
    <Box
      sx={{
        position: "relative",
        py: { xs: 3, md: 6 },
        backgroundImage: `url(${ctaBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
        filter: "contrast(1.08) saturate(1.05)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background: `
      linear-gradient(
        120deg,
        rgba(40, 40, 40, 0.45) 0%,
        rgba(40, 40, 40, 0.32) 40%,
        rgba(40, 40, 40, 0.18) 75%,
        rgba(40, 40, 40, 0.08) 100%
      )
    `,
        }}
      />
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Box
            maxWidth={680}
            sx={{
              mx: { xs: "auto", md: 0 },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            {/* EYEBROW */}
            <Typography
              sx={{
                color: "var(--color-gold)",
                letterSpacing: "0.35em",
                fontSize: 11,
                mb: 2,
                fontWeight: 600,
              }}
            >
              PRIVATE REAL ESTATE CONSULTATION
            </Typography>

            {/* HEADLINE */}
            <Typography
              sx={{
                color: "var(--color-white)",
                fontSize: { xs: "2rem", sm: "2.3rem", md: "3.1rem" },
                fontWeight: 600,
                lineHeight: 1.15,
                mb: 3,
              }}
            >
              Speak With a{" "}
              <Box component="span" sx={{ color: "var(--color-gold)" }}>
                Vision X Nexus Property Expert
              </Box>
            </Typography>

            {/* SUBTEXT */}
            <Typography
              sx={{
                color: "rgba(255,255,255,0.9)",
                fontSize: { xs: 14, md: 16 },
                lineHeight: { xs: 1.7, md: 1.9 },
                mb: 5,
                maxWidth: 620,
                mx: { xs: "auto", md: 0 },
              }}
            >
              Receive confidential guidance, market intelligence, and strategic
              advisory services from our experienced consultants — tailored to
              buying, selling, or investing in luxury real estate across the
              UAE.
            </Typography>

            {/* CTA BUTTONS */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 2.5,
                justifyContent: { xs: "center", md: "flex-start" },
              }}
            >
              {/* PRIMARY CTA */}
              <Button
                component="a"
                href="/contact"
                sx={{
                  height: { xs: 50, md: 56 },
                  px: { xs: 4, md: 5 },
                  borderRadius: "40px",
                  backgroundColor: "var(--color-gold)",
                  color: "var(--color-text-primary)",
                  textTransform: "uppercase",
                  fontSize: 12,
                  letterSpacing: "0.18em",
                  fontWeight: 600,
                  boxShadow: "0 18px 40px rgba(0,0,0,0.18)",
                  "&:hover": {
                    boxShadow: "0 26px 60px rgba(0,0,0,0.25)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                Speak to an Expert
              </Button>

              {/* CALL CTA */}
              <Button
                component="a"
                href="tel:+971547914848"
                startIcon={<CallIcon />}
                sx={{
                  height: { xs: 50, md: 56 },
                  px: { xs: 4, md: 5 },
                  borderRadius: "40px",
                  backgroundColor: "transparent",
                  color: "var(--color-gold)",
                  border: "1px solid var(--color-gold)",
                  textTransform: "uppercase",
                  fontSize: 12,
                  letterSpacing: "0.18em",
                  "&:hover": {
                    backgroundColor: "rgba(207,172,106,0.12)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
               Call Us
              </Button>
            </Box>
          </Box>
        </motion.div>
      </Container>

      {/* SUBTLE GOLD DIVIDER */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "12%",
          right: "12%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.35,
        }}
      />
    </Box>
  );
}
